/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';

import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class MedicalScheduleRoute extends Route {
  // Services
  @service
  store;

  model() {
    return hash({
      group: this.modelFor('group'),
      batches: this.store.findAll('medical/batch'),
      medications: this.store.findAll('medical/medication'),
      logs: this.store.findAll('medical/log'),
      schedules: this.store.findAll('medical/schedule'),
    });
  }
}
